<template>
  <div class="LoginSectionComponentOuter">
    <div class="LoginSectionComponent" v-if="paytmSource != 'app' && currentEnvironment.loginModule != 'BlinkX' && !currentUrl.includes('almondz.stockants.com') && !currentUrl.includes('almondztrade.stockants.com') && currentEnvironment.utm_source != 'Findoc'">
      <div class="top-sections">
        <div class="left-side">
          <img src="../assets/images/LitePlanExpertView/Mobile.gif" class="mobile-gif" alt="" />
        </div>
        <div class="right-section">
          <LoginCardComponent></LoginCardComponent>
          <div class="country-section flex-center">
            <h3>
              StockAnts Welcomes
              <span class="nri-txt">NRIs Investors</span>
            </h3>

            <div class="flex-wrap flex-center">
              <img v-for="i in country_flags" :src="i" alt="" />
            </div>

            <p>Now access curated investment ideas by SEBI Registered Experts, specially designed for NRIs.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="LoginSectionComponent without-login-card" v-else>
      <div class="top-sections">
        <div class="left-side">
          <img src="../assets/images/LitePlanExpertView/Mobile.gif" class="mobile-gif" alt="" />
        </div>
        <div class="right-section">
          <div class="country-section flex-center">
            <h3>
              StockAnts Welcomes
              <span class="nri-txt">NRIs Investors</span>
            </h3>

            <div class="flex-wrap flex-center">
              <img v-for="i in country_flags" :src="i" alt="" />
            </div>

            <p>Now access curated investment ideas by SEBI Registered Experts, specially designed for NRIs.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
      
  <script>
import LoginCardComponent from '../components/LoginCardComponent.vue';

export default {
  name: 'LoginSectionComponent',
  components: { LoginCardComponent },
  data() {
    return {
      country_flags: [require('../assets/images/LitePlanExpertView/Singapore.svg'), require('../assets/images/LitePlanExpertView/Australia.svg'), require('../assets/images/LitePlanExpertView/SaudiArabia.svg'), require('../assets/images/LitePlanExpertView/Oman.svg'), require('../assets/images/LitePlanExpertView/US.svg'), require('../assets/images/LitePlanExpertView/Canada.svg'), require('../assets/images/LitePlanExpertView/Dubai.svg'), require('../assets/images/LitePlanExpertView/UK.svg'), require('../assets/images/LitePlanExpertView/Kenya.svg')],
      currentEnvironment: localStorage.getItem('currentEnvironment') ? JSON.parse(localStorage.getItem('currentEnvironment')) : {},
      currentUrl: '',
      paytmSource: '',
    };
  },
  mounted() {
    this.currentUrl = localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href;
    if (localStorage.getItem('paytmSource')) {
      this.paytmSource = localStorage.getItem('paytmSource');
    }
  },
  methods: {},
  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },
  },
};
</script>
      
<style scoped lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';
.LoginSectionComponent {
  background: rgb(45, 46, 141);
  background: linear-gradient(90deg, rgba(45, 46, 141, 1) 21%, rgba(0, 0, 0, 1) 50%);
  height: 500px;
  margin-top: 350px;
  padding: 0 7%;

  .top-sections {
    position: relative;
  }
  .left-side {
    position: absolute;
    top: -270px;
    width: 400px;
    left: 5%;
    .mobile-gif {
      width: 350px;
    }
  }

  .right-section {
    position: absolute;
    top: -130px;
    right: 0;
    width: 500px;

    // .LoginCardComponent {
    //   //   display: flex;
    //   //   justify-content: center;
    //   //   flex-direction: column;
    // }
    .login-box {
      height: 180px;
    }

    .country-section {
      flex-direction: column;
      color: #ffff;

      h3 {
        font-size: 25px;
        font-weight: 600;
        // margin-top: 50px;
      }

      p {
        font-size: 17px;
        text-align: center;
      }

      .nri-txt {
        color: #fee65f;
      }
      img {
        width: 100px;
      }
    }
  }
  //   1080px
  @media screen and (max-width: 1080px) {
    padding: 0;
    padding-right: 5%;
    height: 1010px;
    margin-top: 245px;
    text-align: center;

    .top-sections {
      position: relative;
      bottom: 200px;
    }

    .left-side {
      position: unset;
      width: auto;
      .mobile-gif {
        width: 300px;
        margin-bottom: 35px;
      }
    }
    .right-section {
      width: auto;
      position: unset;
      .country-section {
        width: 500px;
        margin: 0 auto;
      }

      .login-box {
        height: 100px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    padding-right: unset;
    padding: 0 20px;
    // height: 910px;

    .left-side {
      .mobile-gif {
        // width: 230px;
      }
    }
    .right-section {
      .country-section {
        width: 410px;

        img {
          width: 70px;
        }
      }
    }
  }

  @media screen and (max-width: 500px) {
    // padding: 0 10px;
    height: 960px;
    .right-section .country-section {
      width: 300px;
      margin: 0 auto;

      h3 {
        font-size: 23px;
      }
      p {
        font-size: 12px;
      }

      img {
        width: 60px;
      }
    }
  }
}
.without-login-card {
  height: 400px;
  .right-section {
    margin-top: 200px;
  }

  @media screen and (max-width: 1080px) {
    height: 670px;
    padding: 0;
    .right-section {
      margin-top: 0px;
    }
  }
}
</style>

<style lang="scss">
.LoginSectionComponent {
  .login-card {
    width: 400px !important;
    margin: 0 auto !important;
  }
  @media screen and (max-width: 1080px) {
    .login-card {
      width: 300px !important;
    }
  }
  @media screen and (max-width: 500px) {
    .login-card {
      width: 100% !important;
    }
  }
}
</style>
      